import { connect } from '@atlassian/jira-react-redux';
import type { Sprint } from '../../../model/sprint/sprint-types';
import {
	getIsCMPBoard,
	rapidViewIdSelector,
} from '../../../state/selectors/software/software-selectors';
import {
	activeSprintsSelector,
	getSelectedSprints,
} from '../../../state/selectors/sprint/sprint-selectors';
import { workIssuesSelector } from '../../../state/selectors/work/work-selectors';
import type { State } from '../../../state/types';
import { type Props, CompleteSprintButton } from './view';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export const getAppearanceState = (sprints: Sprint[] | null | void) => {
	if (sprints && sprints[0]?.daysRemaining <= 0) {
		return 'primary';
	}

	return 'default';
};

const mapStateToProps = (state: State): Props => {
	const activeSprints = activeSprintsSelector(state);

	return {
		activeSprints,
		appearance: getAppearanceState(activeSprints),
		boardId: rapidViewIdSelector(state),
		selectedSprintIds: getSelectedSprints(state),
		sourceIssueNo: workIssuesSelector(state).length,
		isCMPBoard: getIsCMPBoard(state),
	};
};

export default connect(mapStateToProps, {})(CompleteSprintButton);
